import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import AccessibleAiImagePng2x from './assets/AccessibleAiImage@2x.png'
import AccessibleAiImageWebp from './assets/AccessibleAiImage.webp'
import AccessibleAiImageWebp2x from './assets/AccessibleAiImage@2x.webp'

const AccessibleAiImage = () => (
  <picture>
    <source type="image/webp" srcSet={`${AccessibleAiImageWebp}, ${AccessibleAiImageWebp2x} 2x`} />
    <StyledImage
      src={AccessibleAiImagePng2x}
      alt="Illustration: Activate data + intelligence."
      width="640"
      height="493"
      loading="lazy"
    />
  </picture>
)

const StyledImage = styled(Image)`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default AccessibleAiImage
